import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/5 bg-[#070d10]">
      <div className="mx-auto max-w-7xl px-5 py-12 lg:px-8">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl brand-gradient text-xs font-extrabold text-[#052027]">A4</span>
              <span className="font-display text-lg font-extrabold">
                <span className="text-gold">AQL</span><span className="text-cyan">4</span>
              </span>
            </div>
            <p className="mt-3 max-w-xs text-sm leading-relaxed text-muted-foreground">
              منصة آقطار الخدمات الرقمية · المدن الذكية السعودية. سجل الثقة الرقمي للتجارة الآمنة والعمل الحر.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white">الخدمات</h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li><Link to="/services" className="text-muted-foreground hover:text-cyan">دفتر AQL</Link></li>
              <li><Link to="/services" className="text-muted-foreground hover:text-cyan">استوديو البناء</Link></li>
              <li><Link to="/services" className="text-muted-foreground hover:text-cyan">الناشر التلقائي</Link></li>
              <li><Link to="/marketplace" className="text-muted-foreground hover:text-cyan">المتجر</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white">التصنيفات</h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li><Link to="/category/cars" className="text-muted-foreground hover:text-cyan">السيارات</Link></li>
              <li><Link to="/category/nature" className="text-muted-foreground hover:text-cyan">الطبيعة والمزارع والطب</Link></li>
              <li><Link to="/category/home" className="text-muted-foreground hover:text-cyan">المنزل والإصلاح</Link></li>
              <li><Link to="/category/furniture" className="text-muted-foreground hover:text-cyan">الأثاث والكتب</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white">تواصل</h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li className="text-muted-foreground">واتساب: <span className="font-en text-cyan" dir="ltr">+966541806681</span></li>
              <li><Link to="/admin" className="text-muted-foreground hover:text-cyan">الإدارة</Link></li>
              <li><Link to="/wallet" className="text-muted-foreground hover:text-cyan">استعلام / المحفظة</Link></li>
              <li><Link to="/legal/privacy" className="text-muted-foreground hover:text-cyan">الخصوصية والشروط</Link></li>
              <li><Link to="/legal/disclaimer" className="text-muted-foreground hover:text-cyan">إخلاء المسؤولية</Link></li>
              <li><Link to="/legal/support" className="text-muted-foreground hover:text-cyan">مركز الدعم</Link></li>
              <li><Link to="/tools" className="text-muted-foreground hover:text-cyan">الوقت والحاسبة</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-white/5 pt-6 text-center text-xs text-muted-foreground">
          © {new Date().getFullYear()} AQL4 · جميع الحقوق محفوظة · بناء أصيل
        </div>
      </div>
    </footer>
  );
}
